import type { AnalyticsType } from '@ria-client/segment/types';
import type { CtaType } from '@ria-client/supergraph/roundup/types';
import { CtaButton } from '@ria-client/tw-shared-ui';

export interface ProductCardRedesignCtaButtonProps {
  cta?: CtaType;
  ctaAnalytics: AnalyticsType;
  federallyInsuredAnnotation?: string;
}

export function ProductCardRedesignCtaButton({
  cta,
  ctaAnalytics,
  federallyInsuredAnnotation,
}: ProductCardRedesignCtaButtonProps) {
  const annotationSuffix = federallyInsuredAnnotation && `, ${federallyInsuredAnnotation}`;
  const ctaWithoutAnnotation =
    cta?.subtext && annotationSuffix && cta.subtext.endsWith(annotationSuffix)
      ? { ...cta, subtext: cta.subtext.slice(0, -annotationSuffix.length) }
      : cta;

  return (
    <div className="flex flex-col gap-2">
      <CtaButton analyticsPayload={ctaAnalytics} cta={ctaWithoutAnnotation} fullWidth hideSubtext />
      {ctaWithoutAnnotation?.subtext && (
        <span className="typography-text-extra-small text-center text-[var(--content-neutral-dark)]">
          {ctaWithoutAnnotation.subtext}
        </span>
      )}
      {cta?.subtext && federallyInsuredAnnotation && (
        <span className="typography-text-extra-small w-full rounded-[4px] bg-[var(--content-yellow-extra-light)] px-3 text-center font-medium text-[var(--content-neutral-darker)]">
          {federallyInsuredAnnotation}
        </span>
      )}
    </div>
  );
}
